import { render, staticRenderFns } from "./PoppableItemText.vue?vue&type=template&id=5c3a000c&scoped=true&"
import script from "./PoppableItemText.vue?vue&type=script&lang=js&"
export * from "./PoppableItemText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3a000c",
  null
  
)

export default component.exports